import * as React from 'react';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import { Select as MuiSelect } from '@mui/material';
import FormHelperText from '@mui/material/FormHelperText';

export default function ShowHideSelect(props) {

  const { name, label, value, error = null, disabled, onChange, options } = props;

  return (
    <Box sx={{ marginTop: 1, marginBottom: 0.4 }}>
    <FormControl
      variant="outlined"
      fullWidth
      size="small"
      {...(error && { error: true })}> 
      <InputLabel>{label}</InputLabel>
      <MuiSelect
        label={label}
        name={name}
        value={value}
        disabled={disabled}
        onChange={onChange}
      >
        <MenuItem value="0">Wybierz</MenuItem>
        {
          options.map(
            columnDef => (<MenuItem key={columnDef.field} value={columnDef.field}>{columnDef.headerName}</MenuItem>)
          )
        }
      </MuiSelect>
      {error && <FormHelperText>{error}</FormHelperText>}
    </FormControl>
    </Box>
  )
}